(function () {
  function funnel(prefix, stepIds, dotIds, felder) {
    var keys = Object.keys(felder);

    function zeige(n) {
      stepIds.forEach(function (id, i) {
        var el = document.getElementById(id);
        if (el) el.classList.toggle('on', i === n - 1);
      });
      dotIds.forEach(function (id, i) {
        var el = document.getElementById(id);
        if (el) el.classList.toggle('act', i <= n - 1);
      });
    }

    document.querySelectorAll('.' + prefix + 'qk').forEach(function (k) {
      k.addEventListener('click', function () {
        var f = k.getAttribute('data-f');
        k.parentElement.querySelectorAll('.' + prefix + 'qk').forEach(function (x) {
          x.classList.remove('sel');
        });
        k.classList.add('sel');
        var ziel = document.getElementById(felder[f]);
        if (ziel) ziel.value = k.getAttribute('data-v');
        setTimeout(function () { zeige(f === keys[0] ? 2 : 3); }, 220);
      });
    });

    document.querySelectorAll('.fzurueck').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = stepIds.indexOf(b.getAttribute('data-step'));
        if (idx > -1) zeige(idx + 1);
      });
    });
  }

  funnel('b', ['bs1', 'bs2', 'bs3'], ['bqs1', 'bqs2', 'bqs3'], { projekt: 'bf-projekt', haushalt: 'bf-haushalt' });
  funnel('f', ['fs1', 'fs2', 'fs3'], ['qs1', 'qs2', 'qs3'], { geschaeft: 'ff-geschaeft', start: 'ff-start' });

  // Nach dem Absenden nur die Danke-Box des tatsaechlich gesendeten Formulars zeigen
  var boxen = document.querySelectorAll('[data-danke]');
  if (boxen.length) {
    var hash = window.location.hash.replace('#', '');
    boxen.forEach(function (box) {
      if (!hash || box.getAttribute('data-danke') === hash) {
        box.hidden = false;
        var form = box.closest('form');
        if (form) {
          form.querySelectorAll('.fstep, .qsteps').forEach(function (el) { el.style.display = 'none'; });
        }
      }
    });
  }

  // Bei Validierungsfehlern direkt zum Kontaktschritt springen
  document.querySelectorAll('.ffehler').forEach(function (fehler) {
    var form = fehler.closest('form');
    if (!form) return;
    var steps = form.querySelectorAll('.fstep');
    steps.forEach(function (s, i) { s.classList.toggle('on', i === steps.length - 1); });
  });
})();
